import "%modules%/header/header";
import "%modules%/footer/footer";
import "%modules%/input/input";
import "%modules%/select/select";
import "%modules%/tabs/tabs";
import "%modules%/slider/slider";
import "%modules%/datepicker/datepicker";
import "%modules%/checkbox/checkbox";
import "%modules%/accordion-item/accordion-item";
// import "%modules%/search-block/search";
import "%modules%/file-item/file-item";
import "%modules%/info-card/info-card";
